<template>
  <o-confirmation-view
    image="images/velo-header.jpg"
    message="Je bestelling is met succes geregistreerd. Je abonnement zal beschikbaar zijn van zodra de verwerking klaar is."
    nav-bar-title="Velo jaarkaart"
  />
</template>

<script>
import OConfirmationView from '@/components/OConfirmationView.vue'
export default {
  name: 'VeloAboConfirmation',
  components: {
    OConfirmationView
  }
}
</script>
